module.exports = __webpack_public_path__ + "static/media/GPS_Logo_dark.2427a0af.png";